import type { IxcSweepsClearingV1SweepParticipantKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const SWEEP_PARTICIPANT_BASE_PATH = getResolvedPath('/clearing/operations/sweep/participant');

export const getSweepsParticipantPath: EntityPathBuilder<IxcSweepsClearingV1SweepParticipantKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return SWEEP_PARTICIPANT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.accountId) {
        return undefined;
      }

      return getResolvedPath(`${SWEEP_PARTICIPANT_BASE_PATH}/$accountId`, context.keys);
    }
  }
};

export function getSweepsParticipantDetailPath(accountId: string | undefined) {
  if (!accountId) {
    return undefined;
  }

  return getSweepsParticipantPath({ kind: 'detail', keys: { accountId } });
}
